import { useState } from 'react'
import { Head, Link } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ProjectControls from '@/frontend/features/Fde/ProjectControls'
import ProjectDialog from '@/frontend/features/Fde/ProjectDialog'
import ProjectManagement from '@/frontend/features/Fde/ProjectManagement'
import { fdeRoutes } from '@/frontend/features/Fde/routes'
import type { ManagementProps, Project } from '@/frontend/features/Fde/types'

function ManagementPage(props: ManagementProps & { work_approvals_path?: string | null; work_approvals_label: string }) {
  const [projectDialog, setProjectDialog] = useState<{ open: boolean; project: Project | null }>({
    open: false,
    project: null,
  })
  const actions = (
    <ProjectControls
      path={fdeRoutes.overview}
      project={props.project}
      projects={props.project_history}
      copy={props.copy}
      canManage={props.can_manage_access}
      onEdit={() => setProjectDialog({ open: true, project: props.project })}
      onNew={() => setProjectDialog({ open: true, project: null })}
    />
  )

  return (
    <>
      <Head title={props.page_title} />
      <FdeShell
        copy={props.copy}
        eyebrow=""
        title={props.project?.name ?? props.organization.name}
        description={props.copy.management.description}
        actions={actions}
        projectId={props.project?.id}
      >
        {props.work_approvals_path && <div className="px-6 pt-4"><Link href={props.work_approvals_path} className="text-sm text-muted-foreground underline-offset-4 hover:underline">{props.work_approvals_label}</Link></div>}
        <ProjectManagement key={`${props.organization.id}:${props.project?.id}:${props.management_section}`} props={props} />
      </FdeShell>
      <ProjectDialog
        open={projectDialog.open}
        onOpenChange={(open) => setProjectDialog((current) => ({ ...current, open }))}
        project={projectDialog.project}
        agents={props.agents}
        copy={props.copy}
        activeProjectId={props.project?.id}
        returnTo="management"
      />
    </>
  )
}

ManagementPage.layout = (page: React.ReactElement) => (
  <DashboardLayout variant="canvas">{page}</DashboardLayout>
)
export default ManagementPage
